import HeroBase from 'components/Hero'

function Hero() {
    return (
        <HeroBase>
            <div className='hero-top'>
                <div>
                    <div className='hero-kicker'>Eyes on Environmental Enforcement Project</div>
                    <h1>Eyes on Environmental Enforcement Document Portal</h1>
                    <p>
                        Search EPA inspection reports, notices of violation,
                        enforcement actions, and information requests obtained
                        through FOIA and public environmental data systems.
                    </p>
                </div>
            </div>
        </HeroBase>
    )
}

export default Hero